module.exports = __webpack_public_path__ + "static/media/partners-3.e999ee31.png";